module.exports = __webpack_public_path__ + "static/media/iconRedError.30bab044.svg";